import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import Ubigeo from "../../commons/ubigeo.module";
import { DataService } from "../../services/data.service";
import NumberFormat from "react-number-format";
const QUERY_CODE = "SNA03";
class BloqueDatosDeRegion extends React.Component {
  static propTypes = {
    idRegion: PropTypes.string,
  };
  constructor(props) {
    super(props);
    this.state = {
      idRegion: props.idRegion,
    };
  }
  render() {
    let { idRegion } = this.props;
    let nombreRegion = Ubigeo.getNombreRegion(idRegion) || "";
    if (idRegion === "00") {
      nombreRegion = "Perú";
    }
    let data = this.props.data || [];
    let data_info = {
      poblacion: 0,
      superficie: 0,
      densidad_poblacional: 0,
      centros_poblados: 0,
      adscritos: "7",
      bosque_comunidades: 0,
      bosque_sedes: 0,
      sernanp_sedes: 0,
      igp_sedes: 0,
      iiap_sedes: 0,
      inaigem_sedes: 0,
      oefa_sedes: 0,
      senace_sedes: 0,
      senamhi_eh: 0,
      senamhi_em: 0,
      senamhi_estaciones: 0,
      senamhi_sedes: 0,
    };
    if (data.length > 0) {
      data_info = {
        adscritos: "7",
        poblacion: data[0].poblacion ? data[0].poblacion : 0,
        superficie: data[0].superficie ? data[0].superficie : 0,
        densidad_poblacional: data[0].densidad_poblacional
          ? data[0].densidad_poblacional
          : 0,
        centros_poblados: data[0].centros_poblados
          ? data[0].centros_poblados
          : 0,
        bosque_comunidades: data[0].bosque_comunidades
          ? data[0].bosque_comunidades
          : 0,
        bosque_sedes: data[0].bosque_sedes ? data[0].bosque_sedes : 0,
        igp_sedes: data[0].igp_sedes ? data[0].igp_sedes : 0,
        iiap_sedes: data[0].iiap_sedes ? data[0].iiap_sedes : 0,
        inaigem_sedes: data[0].inaigem_sedes ? data[0].inaigem_sedes : 0,
        oefa_sedes: data[0].oefa_sedes ? data[0].oefa_sedes : 0,
        senace_sedes: data[0].senace_sedes ? data[0].senace_sedes : 0,
        senamhi_eh: data[0].senamhi_eh ? data[0].senamhi_eh : 0,
        senamhi_em: data[0].senamhi_em ? data[0].senamhi_em : 0,
        senamhi_estaciones: data[0].senamhi_estaciones
          ? data[0].senamhi_estaciones
          : 0,
        senamhi_sedes: data[0].senamhi_sedes ? data[0].senamhi_sedes : 0,
        sernanp_sedes: data[0].sernanp_sedes ? data[0].sernanp_sedes : 0,
      };
    }

    nombreRegion = nombreRegion.toLowerCase();
    return (
      <Row>
          <Col xs={12} sm={12} md={12} xl={12}>
            <div className=" mr-2">
            <p className="text-justify ml-2 mr-2">
            Son <span className="text-primary h5">{data_info.adscritos}</span>{" "}
            los organismos adscritos al Ministerio del Ambiente, los que se
            distribuyen en la Región <span className="text-capitalize">{nombreRegion}</span>  de acuerdo a las actividades
            que desarrollan, en la Región <span className="text-capitalize">{nombreRegion}</span> se cuenta con{" "}
            <span className="text-primary h5">{data_info.sernanp_sedes}</span>{" "}
            Jefaturas o Sedes Administrativas del SERNANP;{" "}
            <span className="text-primary h5">{data_info.bosque_sedes}</span>{" "}
            sedes regionales del PNCBMCC, con intervención en{" "}
            <span className="text-primary h5">
              {data_info.bosque_comunidades}
            </span>{" "}
            comunidades;{" "}
            <span className="text-primary h5">{data_info.senamhi_sedes}</span>{" "}
            Direcciones Zonales del SENAMHI con{" "}
            <span className="text-primary h5">{data_info.senamhi_em}</span>{" "}
            estaciones meteorológicas y{" "}
            <span className="text-primary h5">{data_info.senamhi_eh}</span>{" "}
            estaciones hidrológicas;{" "}
            <span className="text-primary h5">{data_info.oefa_sedes}</span>{" "}
            oficinas desconcertadas del OEFA;{" "}
            <span className="text-primary h5">{data_info.inaigem_sedes}</span>{" "}
            oficinas desconcertadas del{" "}
            <span title="Programa Nacional de Conservación de Bosques">
              INAIGEM
            </span>
            ; <span className="text-primary h5">{data_info.igp_sedes}</span>{" "}
            sedes regionales del IGP;{" "}
            <span className="text-primary h5">{data_info.iiap_sedes}</span>{" "}
            oficinas del IIAP y{" "}
            <span className="text-primary h5">{data_info.senace_sedes}</span>{" "}
            del SENACE.
          </p>
            </div>
          </Col>
        <Col xs={12} sm={12} md={12} xl={12}>
          <div className="card-card-header__padding">
            <h5>Indicadores principales</h5>
          </div>
        </Col>
        <Col xs={12} sm={12} md={12} xl={12}>
        <div className="card-sinia__body mr-3 mb-3">
          <Row>
            <Col xs={6} sm={6} md={3} xl={3}>
            <div className="minicard">
                <div>
                  <span className="minicard__label"><h6>Población</h6></span>
                    <NumberFormat
                      className="h4 text-primary"
                      value={data_info.poblacion || ""}
                      displayType={"text"}
                      thousandSeparator={" "}
                    />
                </div>
              </div>
            </Col>
            <Col xs={6} sm={6} md={3} xl={3}>
            <div className="minicard">
                <div>
                  <span className="minicard__label">
                    <h6>Superficie</h6>
                  </span>
                    <NumberFormat
                      className="h4 text-primary"
                      value={data_info.superficie || ""}
                      displayType={"text"}
                      thousandSeparator={" "}
                    />
                    <span className="text-primary">
                      km<sup>2</sup>
                    </span>
                </div>
              </div>
            </Col>
            <Col xs={6} sm={6} md={3} xl={3}>
            <div className="minicard">
                <div>
                  <span className="minicard__label">
                    <h6>Densidad poblacional</h6>
                  </span>
                    <NumberFormat
                      className="h4 text-primary"
                      value={data_info.densidad_poblacional || ""}
                      displayType={"text"}
                      thousandSeparator={" "}
                    />{" "}
                    <span className="text-primary">
                      Hab./km<sup>2</sup>
                    </span>
                </div>
              </div>
            </Col>
            <Col xs={6} sm={6} md={3} xl={3}>
            <div className="minicard">
                <div>
                  <span className="minicard__label">
                    <h6>Centros poblados</h6>
                  </span>
                    <NumberFormat
                      className="h4 text-primary"
                      value={data_info.centros_poblados || ""}
                      displayType={"text"}
                      thousandSeparator={" "}
                    />
                </div>
              </div>
            </Col>
          </Row>
        </div>
        </Col>
      </Row>
    );
  }
  /**
   * Pide información al servidor
   * @param {String} idRegion
   */
  cargarDatos(idRegion) {
    var me = this;
    DataService.getData(
      {
        query: QUERY_CODE,
        ubigeo: idRegion,
      },
      function(responseData) {
        if (!responseData[QUERY_CODE]) {
          return;
        }
        let data = responseData[QUERY_CODE].data[0];
        me.setState(data);
      }
    );
  }
}
export default BloqueDatosDeRegion;
